module.exports = __webpack_public_path__ + "static/shield_guardian-382dd3e1bc454caf5143001e791518f0.jpeg";